var _excluded = ["as", "asModal", "className", "children", "openHeight", "openWidth", "isOpen", "position", "slideIn", "slim", "slimHeight", "slimWidth", "closeBtnOnClick", "closeTitle", "closeBtnProps", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import AModal from "../AModal/AModal";
import AButton from "../AButton/AButton";
import AIcon from "../AIcon/AIcon";
import "./ADrawer.scss";
var ADrawer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var as = _ref.as,
    propsAsModal = _ref.asModal,
    propsClassName = _ref.className,
    children = _ref.children,
    openHeight = _ref.openHeight,
    openWidth = _ref.openWidth,
    isOpen = _ref.isOpen,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? "fixed" : _ref$position,
    _ref$slideIn = _ref.slideIn,
    slideIn = _ref$slideIn === void 0 ? "left" : _ref$slideIn,
    _ref$slim = _ref.slim,
    slim = _ref$slim === void 0 ? false : _ref$slim,
    slimHeight = _ref.slimHeight,
    slimWidth = _ref.slimWidth,
    closeBtnOnClick = _ref.closeBtnOnClick,
    closeTitle = _ref.closeTitle,
    closeBtnProps = _ref.closeBtnProps,
    propsStyle = _ref.style,
    rest = _objectWithoutProperties(_ref, _excluded);
  // A fixed drawer should automatically render as a modal unless specified
  var shouldRenderModal = propsAsModal || position === "fixed" && propsAsModal == undefined;
  var DrawerPanelComponent = as || "div";
  var orientation = slideIn === "bottom" || slideIn === "top" ? "horizontal" : "vertical";
  var className = "a-drawer a-drawer--".concat(orientation, " a-drawer--").concat(position, " a-drawer--").concat(slideIn);
  var closeButtonClassName = "a-drawer--close-button";
  var style = _objectSpread({}, propsStyle);
  if (slim) {
    className += " a-drawer--slim";
    if (slimWidth) {
      style.width = slimWidth;
      style.maxWidth = slimWidth;
    }
    if (slimHeight) {
      style.height = slimHeight;
      style.maxHeight = slimHeight;
    }
  }
  if (!isOpen) {
    className += " a-drawer--hidden";
  } else if (!slim && openWidth) {
    style.width = openWidth;
  } else if (!slim && openHeight) {
    style.height = openHeight;
  }
  if (propsClassName) {
    className += " ".concat(propsClassName);
  }

  // Our CSS is defaulted to 400px. If a
  // width prop is passed in, that should
  // always take precedence.
  if (openWidth) {
    style.maxWidth = openWidth;
  }
  if (slimWidth && slim) {
    style.maxWidth = slimWidth;
  }
  if (openHeight) {
    style.maxHeight = openHeight;
  }
  if (slimHeight && slim) {
    style.slimHeight = slimHeight;
  }
  var closeButton;
  if (closeBtnOnClick) {
    closeButton = /*#__PURE__*/React.createElement(AButton, _extends({
      className: closeButtonClassName,
      onClick: closeBtnOnClick,
      icon: true,
      tertiaryAlt: true
    }, closeBtnProps), closeTitle ? /*#__PURE__*/React.createElement("div", {
      className: "pa-2"
    }, closeTitle) : /*#__PURE__*/React.createElement(AIcon, null, "close"));
  }
  var drawerPanelComponent = /*#__PURE__*/React.createElement(DrawerPanelComponent, _extends({}, rest, {
    ref: ref,
    className: className,
    style: style
  }), closeButton, children);
  if (!shouldRenderModal) {
    return drawerPanelComponent;
  }
  return /*#__PURE__*/React.createElement(AModal, _extends({
    isOpen: isOpen
  }, rest), drawerPanelComponent);
});
ADrawer.propTypes = {
  /**
   * Sets the base component.
   */
  as: PropTypes.elementType,
  /**
   * Determines if the Drawer should render as a Modal.
   */
  asModal: PropTypes.bool,
  /**
   * String representing class names to be passed to drawer content container.
   * If rendering the drawer as a modal, it will still be passed to the drawer
   * panel content element.
   */
  className: PropTypes.string,
  /**
   * Determines if the drawer is opened or closed. For a permanent
   * drawer, pass a constant value of `true`. An example of when this
   * might be useful is for a sidebar that toggles between its slim and
   * full version.
   */
  isOpen: PropTypes.bool,
  /**
   * The height of the drawer when it is opened. Most commonly used
   * when the drawer slides up from the bottom of the page.
   */
  openHeight: PropTypes.string,
  /**
   * The width of the drawer when it is opened (assuming is is not
   * being rendered with the slim variant). If not specified, defaults
   * to 400px.
   */
  openWidth: PropTypes.string,
  /**
   * Specifies the positioning strategy of the drawer. A drawer specified with
   * "fixed" is useful when the drawer should take up the entire page and cover
   * adjacent content. A drawer specified with absolute is useful when the drawer
   * should be contained within a parent container (so not the entire viewport), but
   * still cover adjacent content as it opens. A drawer specified as relative is
   * useful when the drawer should be contained within a parent, but _not_ cover
   * its adjacent content, i.e., push its adjacent content aside dynamically.
   */
  position: PropTypes.oneOf(["absolute", "fixed", "relative"]),
  /**
   * The direction in which the drawer should slide-in from.
   */
  slideIn: PropTypes.oneOf(["left", "right", "bottom"]),
  /**
   * Determines if the drawer should render as a smaller size. The default
   * is 50px, but you can update this using a maxWidth CSS property on the drawer
   * (either via. style prop or a custom class).
   */
  slim: PropTypes.bool,
  /**
   * The width of the drawer when it is rendered as slim. If not specified,
   * it defaults to 50px.
   */
  slimWidth: PropTypes.string,
  /**
   * Pass onClose handler for Drawer to handle onClose icon and action.
   * Default: x Icon
   */
  closeBtnOnClick: PropTypes.func,
  /**
   * Option for close button title instead of default icon
   */
  closeTitle: PropTypes.string,
  /**
   * Any additional props for close button
   */
  closeBtnProps: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)])
};
ADrawer.displayName = "ADrawer";
export default ADrawer;